import React, {useState, useContext, useRef, useEffect} from 'react';
import {connect, useDispatch} from 'react-redux';
import {LanguageContext} from '../language/lang';
import {get} from 'lodash';
import {Div, IconButton, Title, Shadow, Input} from './Components';
import {COLORS} from '../common/constants';
import {ICClose} from './Icons';
import {useDebounce} from 'use-debounce';
import {getAutocompleteSuggestions} from 'israeli-bank-autocomplete';
import {hideAutoCompleteBank} from '../redux/actions';
import {useId} from './hooks/useId';

function AutoCompleteBank({
  onChange,
  isVisible,
  branch,
  bankCode,
  error,
  app,
  width,
}) {
  const dispatch = useDispatch();
  const lang = useContext(LanguageContext);
  const [input, setinput] = useState(branch || '');
  const [predictions, setpredictions] = useState([]);
  const inputRef = useRef();
  const [, setfocus] = useState(false);
  const [editable, seteditable] = useState(false);
  const [debouncedInput] = useDebounce(input, 200);
  const labelId = useId();

  useEffect(() => {
    if (isVisible && editable)
      setTimeout(() => {
        try {
          inputRef.current.focus();
        } catch (e) {}
      }, 200);
  }, [isVisible, editable]);

  useEffect(() => {
    if (debouncedInput.length > 0) {
      let options = {
        inputType: 'BRANCH_CODE',
      };
      if (bankCode) options.bankCode = bankCode;
      (async () => {
        setpredictions(
          getAutocompleteSuggestions(debouncedInput, options).map(pred => ({
            text:
              lang['branch'] +
              ' ' +
              pred.branchCode +
              ', ' +
              pred.city +
              ', ' +
              pred.branchAddress,
            code: pred.branchCode,
          })),
        );
      })();
    } else {
      setpredictions([]);
    }
  }, [debouncedInput]);

  let mainColor = COLORS.mainColorSender;
  if (app === 'courier') {
    mainColor = COLORS.mainColorCourier;
  }
  return isVisible ? (
    <Div style={styles.mainContainer} role="dialog" aria-labelledby={labelId}>
      <Div style={styles.mainBG} keyboardShouldPersistTaps="always">
        <Div theme="flex-row jc-space-between">
          <IconButton
            title="close"
            onClick={() => dispatch(hideAutoCompleteBank())}>
            <ICClose color={mainColor} width={25} height={40} />
          </IconButton>
          <Title id={labelId} style={styles.title(mainColor)}>
            enter-branch-code
          </Title>
          <Div style={{width: 30}} />
        </Div>
        <Div>
          <Div
            style={{
              marginHorizontal: 10,
              height: 60,
              backgroundColor: '#f0f0f0',
              borderColor: error ? 'red' : '#f0f0f0',
              borderRadius: 0,
              borderWidth: 1,
              color: COLORS.black,
              fontSize: 17,
              paddingBottom: 4,
              paddingLeft: 0,
              paddingRight: 0,
              paddingTop: 4,
              lineHeight: 24,
            }}
            theme="flex-row jc-space-between">
            <Input
              ref={inputRef}
              value={input}
              onBecameEditable={() => seteditable(true)}
              onFocus={() => setfocus(true)}
              onBlur={() => setfocus(false)}
              onChange={val => setinput(val)}
              type="number"
              style={{
                fontSize: 17,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 14,
                paddingRight: 14,
                width: width - 65,
                borderWidth: 0,
                color: COLORS.black,
              }}
            />
            <IconButton title="clear" onClick={() => setinput('')}>
              <ICClose width={25} height={30} color={mainColor} />
            </IconButton>
          </Div>
          <Div style={{height: 10}} />
          <Shadow />
          <Div>
            {predictions.slice(0, 6).map((pred, i) => (
              <IconButton
                title={pred.text}
                key={i}
                onClick={() => selectBranch(pred)}
                style={{
                  borderBottomWidth: 1,
                  borderColor: '#dddddd',
                  padding: 15,
                }}>
                <Div theme="flex-row">
                  <Title
                    style={{
                      fontSize: 16,
                      textAlign: 'auto',
                    }}>
                    {pred.text}
                  </Title>
                </Div>
              </IconButton>
            ))}
            {debouncedInput.length > 0 ? (
              <IconButton
                title={debouncedInput}
                onClick={() =>
                  selectBranch({text: debouncedInput, code: debouncedInput})
                }
                style={{
                  borderBottomWidth: 1,
                  borderColor: '#dddddd',
                  padding: 15,
                }}>
                <Div theme="flex-row">
                  <Title
                    style={{
                      fontSize: 16,
                      textAlign: 'auto',
                    }}
                    noTranslate>
                    {debouncedInput}
                  </Title>
                </Div>
              </IconButton>
            ) : null}
          </Div>
        </Div>
      </Div>
    </Div>
  ) : null;
  async function selectBranch(pred) {
    dispatch(hideAutoCompleteBank());
    if (typeof onChange === 'function') {
      onChange(pred.code);
    }
  }
}

const styles = {
  mainBG: {
    backgroundColor: '#FCFCFC',
    height: '100%',
  },
  mainContainer: {
    backgroundColor: '#000000',
    flex: 1,
  },
  selectedTab: {
    borderColor: COLORS.mainColorSender,
  },
  shadow: {
    height: 4,
  },
  tabButton: {
    backgroundColor: 'transparent',
    borderBottomWidth: 4,
    borderColor: 'transparent',
    borderRadius: 0,
    width: '50%',
  },
  tabText: {
    color: COLORS.black,
  },
  title: color => ({
    lineHeight: 53,
    fontSize: 16,
    color,
  }),
};

const mapStateToProps = state => ({
  app: state.app,
  width: get(state, 'window.width', 0),
  branch: get(state, 'autocompleteBank.branch', ''),
  bankCode: get(state, 'autocompleteBank.bankCode', ''),
  error: get(state, 'autocompleteBank.error', ''),
  onChange: get(state, 'autocompleteBank.onChange'),
});

export default connect(mapStateToProps)(AutoCompleteBank);
